import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Button, Card, Col, Row,
} from 'antd';
import ArticuloFotoGrid from '../../../articulos/containers/BuscadorArticulos';
import ArticuloFittingBox from '../../../articulos/components/dataDisplay/ArticuloFittingBox.datadisplay';
import { Box } from '../../../shared/components';
import { addArticleToEncargo, eliminarArticuloDeEncargo } from '../../../../state/actions/creators/encargos.actioncreator';

class PresupuestoRapidoFittingBoxPage extends Component {

  componentDidMount() {
    const { history, articulo } = this.props;
    if (articulo === undefined) {
      history.goBack();
    }
  }

  reemplazarArticulo({ articulo }) {
    const { addArticleToEncargo, eliminarArticuloDeEncargo, articulo: articuloToRemove, encargo } = this.props;
    const { id } = encargo;
    addArticleToEncargo({ articulo, encargoId: id });
    eliminarArticuloDeEncargo({ encargoId: id, articulo: articuloToRemove });
  }

  render() {
    const { articulo, history } = this.props;
    if (articulo === undefined) {
      return <div />;
    }
    const { id: articuloId } = articulo;
    return (
      <Box>
        <Row>
          <Col xs={{ span: 24 }} md={{ span: 15 }} style={{ position: 'sticky', top: '0' }}>
            <Box p="8">
              <Card>
                <ArticuloFittingBox />
                <Box pt="16">
                  <Button
                    block
                    type="primary"
                    onClick={() => history.push('/presupuestorapido/pel')}>
                    Quiero esta montura
                  </Button>
                </Box>
              </Card>
            </Box>
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 9 }}>
            <Box p="8">
              <ArticuloFotoGrid
                searchable={false}
                reload={false}
                seleccionId={articuloId}
                numeroDeArticulos={12}
                gluedFilter={{ 'tipo.id': { valor: 3, operador: 'eq' }, obsoleto: { valor: 'F', operador: 'eq' } }}
                endpoint="MONTURAS_PRESUPUESTO_RAPIDO"
                onVRClick={seleccion => console.error(seleccion)}
                onSeleccion={seleccion => this.reemplazarArticulo(seleccion) }
              />
            </Box>
          </Col>
        </Row>
      </Box>
    );
  }
}

PresupuestoRapidoFittingBoxPage.propTypes = {};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ addArticleToEncargo, eliminarArticuloDeEncargo }, dispatch);
}

const mapStateToProps = (state) => {
  const { encargosWorkspace } = state;

  const {
    encargos,
  } = encargosWorkspace;


  let articulo;
  let encargo;

  if (encargos) {
    encargo = encargos[0];
    if (encargo) {
      const { articulos } = encargo;
      if (articulos) {
        articulo = articulos[0];
      }
    }
  }

  return {
    encargo,
    articulo,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PresupuestoRapidoFittingBoxPage);
